import { makeGet } from '../../utils/call-api-endpoint';
import type { Envelope } from '../../utils/envelope';
import type { Modulo, PermisoEnModulo } from './modulo';

export async function obtenerPermisosDisponibles(): Promise<Envelope<Modulo[]>> {
  const response = await makeGet<Modulo[]>(`/permisos/disponibles`);
  return response;
}

export async function obtenerPermisosPorUsuario(idUsuario: string): Promise<Envelope<PermisoEnModulo[]>> {
  const response = await makeGet<PermisoEnModulo[]>(`/permisos/usuario/${idUsuario}`);
  return response;
}
